import React, { useEffect, useRef } from "react";

import { LoadingIndicator } from "@formant/ui/component/common/LoadingIndicator";

import { useRouter } from "../../context/RouterContext";

export interface INavigateProps {
    to: string;
    hideLoader?: true;
    replace?: boolean;
}

export function Navigate(props: INavigateProps) {
    const { to, replace, hideLoader } = props;
    const initialized = useRef(false);
    const done = useRef(false);
    const { navigate } = useRouter();

    useEffect(() => {
        if (initialized.current) {
            return;
        }
        initialized.current = true;

        if (done.current) {
            return;
        }

        void (async () => {
            void navigate(to, { replace });
            done.current = true;
        })();
    }, [initialized, done, to, replace, navigate]);

    if (done.current || hideLoader) {
        return null;
    }

    return <LoadingIndicator visible={true} />;
}
